import m from "./../../../dist/es2015/locales/es_ES.js";
export const am5locales_es_ES = m;